import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DashboardNavbar from '../components/Header';

const BackButton = styled.div`
  background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  color: #fff;
  padding: 10px 20px;
  font-weight: bold;
  font-size: 0.95rem;
  text-align: center;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  
  &:hover {
   background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  }
  
  @media (max-width: 768px) {
    padding: 8px 15px;
    font-size: 0.9rem;
  }
  
  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 0.8rem;
    border: 1px solid #fff;
  }
`;

const TitleHeader = styled.div`
  background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  color: #fff;
  padding: 10px 20px;
  font-weight: bold;
  font-size: 0.95rem;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    padding: 8px 15px;
    font-size: 0.9rem;
  }
  
  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 0.8rem;
    border: 1px solid #fff
  }
`;

const TableContainer = styled.div`
  background: #e8e8e8;
  height: calc(100vh - 180px);
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  flex: 1;
  min-height: 0;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  width: 100%;
  height: 100%;
  max-width: 100%;
  border: 1px solid #b2c8b2;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    flex-shrink: 0;
  }
  
  tbody {
    display: block;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
  
  thead tr,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  
  @media (max-width: 768px) {
    tbody {
      max-height: calc(100vh - 260px);
    }
  }
`;

const StyledThead = styled.thead`
 background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
`;

const StyledTh = styled.th`
  color: #fff;
  padding: 8px 6px;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid #b2c8b2;
  text-align: left;
  font-size: 0.85rem;
  
  @media (max-width: 768px) {
    padding: 6px 4px;
    font-size: 0.75rem;
  }
  
  @media (max-width: 480px) {
    padding: 5px 3px;
    font-size: 0.7rem;
  }
`;

const StyledTd = styled.td`
  padding: 6px 6px;
  text-align: left;
  color: #222;
  font-size: 0.8rem;
  border: 1px solid #e0e0e0;
  background: #fff;
  word-break: break-word;
  
  @media (max-width: 768px) {
    padding: 5px 4px;
    font-size: 0.75rem;
  }
  
  @media (max-width: 480px) {
    padding: 4px 3px;
    font-size: 0.7rem;
  }
`;

const StyledTr = styled.tr`
  background: #fff;
  
  &:hover {
    background: #f9f9f9;
  }
`;

const Copyright = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  color: black;
  padding: 10px 20px;
  text-align: center;
  font-size: 0.85rem;
  z-index: 100;
  flex-shrink: 0;
  
  @media (max-width: 480px) {
    padding: 8px 15px;
    font-size: 0.75rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`;

const History = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setUserData(JSON.parse(user));
    } else {
      alert("User is not logged in. Please log in to view your bets.");
    }
  }, []);

  const fetchBets = async () => {
    if (userData) {
      try {
        const userId = userData.id;
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/userledgermatchwise/${userId}`);
        console.log(response.data,"ledger")
        if (response.data.success && response.data.data) {
          // Sort by match name for consistent display
          const sortedData = response.data.data.sort((a, b) => {
            if (a.match < b.match) return -1;
            if (a.match > b.match) return 1;
            return 0;
          });
          // Reverse the order to show from top to bottom
          setData(sortedData.reverse());
        } else {
          setData([]);
        }
      } catch (err) {
        console.error('Error fetching bets:', err);
        setData([]);
      }
    }
  };

  useEffect(() => {
    if (userData) {
      fetchBets();
    }
  }, [userData]);

  // Helper function to get winner text (showing NA for now as winner data is not in API response)
  const getWinnerText = (matchName) => {
    // You can enhance this by fetching winner data from another API if available
    // For now, return "NA" as per requirement
    return "NA";
  };

  // Calculate running balance based on profit/loss from first entry
  // Balance = Cumulative sum of profit/loss from first entry to current entry
  const calculateBalance = (index) => {
    if (data.length === 0 || index < 0) return 0;
    
    // Calculate cumulative sum of profit/loss from first entry to current entry
    let balance = 0;
    for (let i = 0; i <= index && i < data.length; i++) {
      const item = data[i];
      const totalPL = parseFloat(item.totalPL) || 0;
      balance += totalPL;
    }
    
    return Number(balance.toFixed(2));
  };

  return (
    <Wrapper>
      <DashboardNavbar/>
      <BackButton onClick={() => navigate('/')}>
        BACK TO MAIN MENU
      </BackButton>
      <TitleHeader>MY LEDGER</TitleHeader>
      <TableContainer>
        <Card>
          <StyledTable>
            <StyledThead>
              <tr>
                <StyledTh>Match Name</StyledTh>
                <StyledTh>Won By</StyledTh>
                <StyledTh>Won</StyledTh>
                <StyledTh>Lost</StyledTh>
                <StyledTh>Balance</StyledTh>
              </tr>
            </StyledThead>
            <tbody>
              {data.length === 0 ? (
                <StyledTr>
                  <StyledTd colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                    No ledger data found
                  </StyledTd>
                </StyledTr>
              ) : (
                data.map((item, index) => {
                  const totalPL = parseFloat(item.totalPL) || 0;
                  const won = totalPL > 0 ? totalPL : 0;
                  const lost = totalPL < 0 ? Math.abs(totalPL) : 0;
                  const balance = calculateBalance(index);
                  
                  return (
                    <StyledTr key={index}>
                      <StyledTd>{item.match || 'N/A'}</StyledTd>
                      <StyledTd>{getWinnerText(item.match)}</StyledTd>
                      <StyledTd style={{ 
                        color: won > 0 ? '#28a745' : '#222',
                        fontWeight: won > 0 ? '600' : '400'
                      }}>
                        {won.toFixed(2)}
                      </StyledTd>
                      <StyledTd style={{ 
                        color: lost > 0 ? '#dc3545' : '#222',
                        fontWeight: lost > 0 ? '600' : '400'
                      }}>
                        {lost.toFixed(2)}
                      </StyledTd>
                      <StyledTd style={{ 
                        color: balance < 0 ? '#dc3545' : balance > 0 ? '#28a745' : '#222',
                        fontWeight: '600'
                      }}>
                        {balance.toFixed(2)}
                      </StyledTd>
                    </StyledTr>
                  );
                })
              )}
            </tbody>
          </StyledTable>
        </Card>
      </TableContainer>
      <Copyright>Copy Right @9xbet24.com</Copyright>
    </Wrapper>
  );
};

export default History;
